// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--mzpXK";
export var Footer = "styles-module--Footer--a8Mbk";
export var Link = "styles-module--Link--vVqbX";
export var Message = "styles-module--Message--Y5Zz7";
export var Wrapper = "styles-module--Wrapper--mA7mQ";